<template>
  <div>
    <div class="field-item-list">
      <div class="field-title">
        <span v-if="title" class="field-title__text">{{ title }}</span>
        <div v-if="infoTooltip?.text || infoTooltip?.action" class="radio-tooltip-icon">
          <md-icon :mdSvg="infoTooltip.svgIcon" v-if="infoTooltip?.text" />
          <md-tooltip md-direction="top" className="radio-tooltip" v-if="infoTooltip?.text">
            {{ infoTooltip.text }}
          </md-tooltip>
          <md-button v-else class="md-icon-button" @click="infoTooltip.action">
            <md-icon :mdSvg="infoTooltip.svgIcon" />
          </md-button>
        </div>
      </div>
      <span v-if="subtitle" class="md-caption subtitle">{{ subtitle }}</span>
      <md-list-item :class="props.class">
        <slot></slot>
      </md-list-item>
    </div>
    <div class="conditional-nested-wrapper">
      <slot name="conditionalNested"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, toRefs } from 'vue';
const props = defineProps({
  title: String,
  class: String,
  subtitle: String,
  infoTooltip: Object,
});

const { title, subtitle, infoTooltip } = toRefs(props);
</script>

<style lang="scss" scoped>
@import '../../../vars.scss';
:deep(.field-name) {
  color: $text-contrast-60;
  font-size: 14px;
}
.conditional-nested-wrapper {
  :deep(.nested) {
    padding-left: 0;
    width: 100%;
    .md-inset .md-list-item-container {
      padding: 0 32px;
    }
  }
}
:deep(.field-value-text) {
  color: $text-contrast-87;
  font-size: 16px;
  white-space: pre-line;
  max-height: 40px;
  display: block;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
:deep(.md-input-container) {
  &.md-input-placeholder {
    label {
      margin-top: -3px;
      pointer-events: auto;
      top: 0;
      opacity: 1;
      font-size: 14px;
    }
  }
  textarea {
    max-height: none;
  }
  &.md-has-value,
  &.md-input-focused {
    label {
      margin-top: -3px;
      font-size: 14px;
    }
  }
  &.md-has-select {
    &:after {
      height: 1px;
    }
  }
  .md-input {
    height: 32px;
  }
  .md-prefix,
  .md-suffix {
    align-self: center;
  }
  .md-suffix {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.54);
  }
  .hint-text {
    position: absolute;
    top: 50px;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
    animation: all 0.5s;
    margin-bottom: 30px;
  }
}
:deep(.field-caption) {
  font-size: 12px;
  color: $text-contrast-60;
  line-height: 14px;
  margin-top: -20px;
  display: block;
  margin-bottom: 12px;
  width: 100%;
  width: 85%;
  @media (max-width: 600px) {
    width: 79%;
  }
}
:deep(.md-input-container.md-input-invalid + .field-caption) {
  display: none;
}
:deep(.no-wrap) {
  width: 100%;
  flex-wrap: nowrap;
  > .md-input-container {
    margin-top: 8px;
  }
}
.field-item-list {
  display: flex;
  flex-direction: column;
  list-style: none;
}
.field-title {
  display: flex;
  align-items: center;
  gap: 10px;
  .md-icon {
    color: $text-contrast-60;
  }
  &__text {
    font-size: 16px;
    padding-left: 16px;
  }
}
.md-caption.subtitle {
  padding-left: 16px;
  padding-top: 8px;
}
</style>
